export default "__VITE_ASSET__eCMTMZFW__"